import { axiosInstance } from '../../api';
const BASE_PATH = '/user_settings';

//Initialize calendar API Call
export let getCalenderConfigurations = async (connection, state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_parameters_to_initiate_calender_connection', {
            connection_type: connection,
            connection_state: state
        })
        return value;
    } catch (error) {
        return error
    }
}

//Establish Calendar API Call
export let establishCalendarConnection = async (connection, code) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/establish_calendar_connection', {
            connection_type: connection,
            code: code
        })
        return value;
    } catch (error) {
        return error
    }
}

//get user data API Call (Forgot Password)
export let getUserData = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_user_info');
        return value;
    } catch (error) {
        return error
    }
}

//get user calendar data API Call (Forgot Password)
export let getCalendarData = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_user_calendar_settings');
        return value;
    } catch (error) {
        return error
    }
}

//disconnect calendar API Call (Forgot Password)
export let disconnectCalendarConnection = async (connection) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disconnect_calendar_connection', {
            connection_type: connection
        });
        return value;
    } catch (error) {
        return error
    }
}

//Change Password API Call (Forgot Password)
export let changePassword = async (oldPassword, password) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/change_password', {
            old_password: oldPassword,
            new_password: password,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Change user name API Call (Forgot Password)
export let changeUserName = async (fname, lname) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/change_user_full_name', {
            first_name: fname,
            last_name: lname,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Change user position API Call (Forgot Password)
export let changeUserPosition = async (position) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/change_user_position', {
            position: position,
        })
        return value;
    } catch (error) {
        return error
    }
}